import withFlashMessages from "web/core/withFlashMessages";

export default () => {
  const rootMemory = typeof window !== "undefined" ? window : {};
  return withFlashMessages(rootMemory, "flashMessages");
};
